import { MarketTabs } from './component';
import { mapStateToProps, mapDispatchToProps } from './redux';
import { connect } from 'react-redux';


export default connect(mapStateToProps, mapDispatchToProps)(MarketTabs);
